var map = {
	"./courseCover.png": 885,
	"./cover-placeholder.png": 886,
	"./heart.svg": 887,
	"./lemon.svg": 888,
	"./sad_turtle.png": 889,
	"./timun_logo.png": 890,
	"./video-placeholder.png": 891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 884;